@if (!(loading$ | async)) {
  <mat-dialog-content>
    <div class="flex flex-col gap-4 m-4">
      @if (showAddressBook$ | async) {
        <mat-form-field>
          <mat-label i18n>Address Book</mat-label>
          <mat-select [formControl]="addressBook" (selectionChange)="changeAddressBook($event.value)">
            @for (addressBook of addressBooks$ | async; track addressBook) {
              <mat-option [value]="addressBook.id">
                {{ addressBook.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <app-card-form [cardType]="cardTypes.CONTACT"></app-card-form>
      <mat-form-field>
        <mat-label i18n>Reference</mat-label>
        <input matInput [formControl]="reference" (change)="changeReference()">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex align-center justify-end w-full">
      <button mat-button (click)="cancel()" i18n>Cancel</button>
      @if (!(saving$ | async)) {
        <button matButton="filled" (click)="save()" [disabled]="disableSave$ | async" i18n>
                Save
            </button>
      }
      @if (saving$ | async) {
        <button matButton="filled" [disabled]="true" i18n>
                Saving
                <app-icon icon="spinner" [spin]="true"></app-icon>
            </button>
      }
    </div>
  </mat-dialog-actions>
}

@if (loading$ | async) {
  <div class="flex flex-col gap-4 m-16 justify-center items-center">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}